import React from 'react';
import useSWR from 'swr';
import { Container, Box, CircularProgress } from '@mui/material';
import CalendarHeader from './components/CalendarHeader';
import EventList from './components/EventList';
import { CalendarEvent } from './types/event';
import { baseBackendUrl } from './service/baseService';

const fetcher = (url: string) => fetch(url).then((r) => r.json());

const UpcomingEvents = () => {
    const { data, error, isLoading } = useSWR<CalendarEvent[]>(
        `${baseBackendUrl}/api/Announcement`,
        fetcher
    );

    // Process events: filter for events (those with start and end times) and sort by start date
    const events = React.useMemo(() => {
        if (!data) return [];
        return data
            .filter(event => event.startDateTime && event.endDateTime)
            .sort((a, b) => new Date(a.startDateTime).getTime() - new Date(b.startDateTime).getTime());
    }, [data]);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: 'linear-gradient(to bottom, #f8f9fa, #ffffff, #f8f9fa)',
                position: 'relative',
                py: { xs: 8, md: 12 },
                px: 2
            }}
        >
            <Container maxWidth="md">
                <CalendarHeader />

                {isLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
                        <CircularProgress color="primary" />
                    </Box>
                ) : error ? (
                    <Box
                        sx={{
                            p: 2,
                            bgcolor: 'error.light',
                            borderRadius: 2,
                            textAlign: 'center',
                            color: 'error.dark',
                            fontWeight: 600
                        }}
                    >
                        Unable to load upcoming events from server.
                    </Box>
                ) : events.length === 0 ? (
                    <Box
                        sx={{
                            p: 2,
                            bgcolor: 'info.light',
                            borderRadius: 2,
                            textAlign: 'center',
                            color: 'info.dark',
                            fontWeight: 600
                        }}
                    >
                        No upcoming events found on server.
                    </Box>
                ) : (
                    <EventList events={events} />
                )}

                {/* Footer accent */}
                <Box
                    component="footer"
                    sx={{
                        mt: 8,
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                >
                    <Box
                        sx={{
                            height: 4,
                            width: 80,
                            borderRadius: 2,
                            bgcolor: 'primary.main',
                            opacity: 0.2
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

export default UpcomingEvents;
